import Axios from "axios";
import React from "react";
import HOST_URL from "../../configs/api";
import { Card } from "../Card";
import { Loading } from "../Loader";
import { Select } from "../Select";
import toastMessage from "../toastMessage";
import AppClass from "../../AppClass";
import { Body, Header, Footer, Modal } from "../Modal";
import Pagination from "../Pagination/Pagination";
import DropdownButton from "../DropdownButton";

let copyData = [];

class Clients extends React.Component {
  state = {
    data: [],
    error: {},
    epesi_members: [],
    selected_member: {},
    limit: 10,
    page: 1,
    totalItemsCount: 0,
    editingMember: null,
    memberDetails: {
      phone_number: '',
      member_no: '',
      user_name: ''
    }
  };

  componentDidMount = async () => {
    if (this.props.apps.length > 0) {
      this.getRegisteredMembers(true, await this.getAppIds(this.props.apps));
    }
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.apps !== this.props.apps) {
      this.getRegisteredMembers(true, await this.getAppIds(this.props.apps));
    }
  };

  getRegisteredMembers = async (isLoading, app_ids) => {
    this.setState({ isLoading });

    const options = {
      method: "POST",
      url: HOST_URL.url + "/get_registered_account",
      data: {
        from_dil: false,
        app_id: app_ids,
      },
      headers: {
        authorization: `Bearer ${this.props.token}`,
      },
    };

    try {
      const data = await Axios(options);
      const result = data?.data?.data || [];
      this.setState({ isLoading: false, data: result });
      copyData = result;
    } catch (error) {
      this.setState({ isLoading: false });
      toastMessage("error", error);
    }
  };

  filterBySacco(e) {
    this.getRegisteredMembers(true, [e.value]);
  }

  getAppIds = async (apps) => {
    const app_ids = await AppClass.get_app_ids(apps);
    return app_ids;
  };

  onSearch(e) {
    let search_txt = e.target.value,
      array = [];
    this.setState({ search_txt });

    for (let item of copyData) {
      if (
        JSON.stringify(item).toLowerCase().indexOf(search_txt.toLowerCase()) !==
        -1
      ) {
        array.push(item);
      }
    }

    this.setState({ data: array });
  }

  onChangeText(field, e) {
    this.setState({
      [field]: e.target ? e?.target?.value : e,
    });

    if (field === "form_sacco") {
      this.getSaccoClients(e.value);
    }
  }

  onCheck(e) {
    this.setState({
      isAllMembers: e.target.checked,
      epesi_member: e.target.checked ? this.state.epesi_members : undefined,
    });
  }

  getSaccoClients(app_id) {
    this.setState({ isLoadingClient: true });

    const config = {
      method: "GET",
      url: HOST_URL.mobitill_url + "/clients?0[]=appid&1[]=" + app_id,
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
    };
    Axios(config)
      .then((data) => {
        let epesi_members = [];
        for (let client of data.data.data) {
          if (!this.registeredMembers().includes(client.mobilenumber)) {
            epesi_members.push({
              label: client.name || client.mobilenumber,
              value: client._id,
              phone: client.mobilenumber,
            });
          }
        }
        this.setState({ isLoadingClient: false, epesi_members });
      })
      .catch((error) => {
        this.setState({ isLoadingClient: false });

        toastMessage("error", error);
      });
  }

  registeredMembers() {
    let ids = [];

    for (let member of this.state.data) {
      if (!ids.includes(member.phone_number)) {
        ids.push(member.phone_number);
      }
    }

    return ids;
  }

  handleOpenModal(modal) {
    this.setState({ [modal]: true });
  }

  handleCloseModal(modal) {
    this.setState({ 
      [modal]: false,
      selected_member: {},
      epesi_member: undefined,
      error: {},
      memberDetails: {
        phone_number: '',
        member_no: '',
        user_name: ''
      }
    });
  }

  validateForm() {
    let { error, epesi_member, form_sacco } = this.state;

    if (!epesi_member || epesi_member?.length === 0) {
      error.epesi_member = "Please select sacco member";
    }

    if (!form_sacco) {
      error.form_sacco = "Please select sacco";
    }

    this.setState({ error });
  }

  handleEdit = (member) => {
    this.setState({
      form_modal: true,
      selected_member: member,
      memberDetails: {
        phone_number: member.phone_number || '',
        member_no: member.member_no || '',
        user_name: member.user_name || ''
      }
    });
  };

  handleMemberDetailsChange = (field, e) => {
    this.setState(prevState => ({
      memberDetails: {
        ...prevState.memberDetails,
        [field]: e.target.value
      }
    }));
  };

  getMemberActions = (member) => {
    return [
      {
        text: "Edit",
        icon: "fa-edit",
        iconColor: "#F79222",
        onClick: () => this.handleEdit(member)
      },
      {
        text: "Delete",
        icon: "fa-trash",
        iconColor: "#F9394C",
        onClick: () => this.onDelete(member.user_id),
      }
    ];
  };

  onSubmit = async () => {
    let { error, form_sacco, selected_member, memberDetails, epesi_member } = this.state;

    if (Object.keys(error).length === 0) {
      this.setState({ isSubmitting: true });

      try {
        if (selected_member?.user_id) {
          // Update existing member
          const updateBody = {
            model: "register",
            user_id: selected_member.user_id,
            app_id: selected_member.app_id,
            ...memberDetails,
            status: "active" // Ensure status is set for update
          };

          await Axios.post(`${HOST_URL.url}/update_registered_account`, updateBody, {
            headers: { authorization: `Bearer ${this.props.token}` }
          });

          toastMessage("success", "Member updated successfully");
        } else {
          await this.validateForm();
          // Import all selected members
          const membersToImport = Array.isArray(epesi_member) ? epesi_member : [epesi_member];
          for (const member of membersToImport) {
            const createBody = {
              model: "register",
              app_id: form_sacco.value,
              user_name: member.label,
              user_id: member.value,
              phone_number: member.phone,
            };
            await Axios.post(`${HOST_URL.url}/register`, createBody, {
              headers: { authorization: `Bearer ${this.props.token}` }
            });
          }

          toastMessage("success", `${membersToImport.length} member(s) imported successfully`);
        }

        // Await refresh so state.data is current before the modal closes —
        // this ensures getSaccoClients filters correctly on the next open
        await this.getRegisteredMembers(true, await this.getAppIds(this.props.apps));

        this.setState({
          form_sacco: undefined,
          epesi_member: undefined,
          memberDetails: {
            phone_number: '',
            member_no: '',
            user_name: ''
          },
          selected_member: {},
          isSubmitting: false,
          form_modal: false
        });

      } catch (error) {
        this.setState({ isSubmitting: false });
        toastMessage("error", error?.response?.data?.message || "Operation failed");
      }
    }
  };

  onDelete = async (user_id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      this.setState({ isLoading: true });

      const url = `${HOST_URL.url}/update_registered_account`;

      const body = {
        model: "register",
        user_id,
        status: "deleted"
      };

      try {
        await Axios.post(url, body, {
          headers: {
            authorization: `Bearer ${this.props.token}`
          }
        });

        toastMessage("success", "Member has been deleted successfully");
        this.getRegisteredMembers(true, await this.getAppIds(this.props.apps));
      } catch (error) {
        toastMessage("error", error?.response?.data?.message || "Failed to delete member");
      } finally {
        this.setState({ isLoading: false });
      }
    }
  };

  handleChangeLimit(e) {
    this.setState({
      limit: e.target.value,
      page: 1,
    });
  }

  handlePagination(page) {
    this.setState({
      page,
    });
  }

  render() {
    return (
      <div>
        <Card className="col-md-12">
          <div className="panel-body">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1, marginRight: 20 }}>
                <Select
                  options={this.props.apps}
                  onChange={this.filterBySacco.bind(this)}
                />
              </div>
              <div style={{ flex: 1, marginRight: 25 }}>
                <div>
                  <input
                    placeholder="Search member name..."
                    className="form-control form-control-lg"
                    value={this.state.search_txt}
                    onChange={this.onSearch.bind(this)}
                  />
                </div>
              </div>
              <div>
                <button
                  className="btn btn-default"
                  onClick={() => this.handleOpenModal("form_modal")}
                >
                  <i className="fa fa-plus" style={{ marginRight: 10 }} />
                  New Member
                </button>
              </div>
            </div>
          </div>
        </Card>

        <Card className="col-md-12">
          {this.state.isLoading ? (
            <Loading icon="fa fa-spinner fa-spin" />
          ) : (
            <div className="panel-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Member No</th>
                    <th>Phone Number</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data
                    .slice(
                      (this.state.page - 1) * this.state.limit,
                      this.state.page * this.state.limit
                    )
                    .map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.user_name}</td>
                          <td>{item.member_no || ''}</td>
                          <td>{item.phone_number}</td>
                          <td width={100} align="right">
                            <DropdownButton 
                              buttonText="Select Action"
                              actions={this.getMemberActions(item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                totalItemsCount={this.state.data.length}
                page={this.state.page}
                limit={this.state.limit}
                handleChangeLimit={this.handleChangeLimit.bind(this)}
                handlePagination={this.handlePagination.bind(this)}
              />
            </div>
          )}
        </Card>

        <Modal show={this.state.form_modal}>
          <Header>
            <h5 className="modal-title">
              {this.state.selected_member?.user_id ? 'Edit Member' : 'New Member'}
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => {
                this.handleCloseModal("form_modal");
                this.setState({ selected_member: {}, epesi_member: undefined });
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Header>
          <Body>
            <div className="panel">
              <div className="row">
                {this.state.selected_member?.user_id ? (
                  <>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Member Name <span className="required">(*)</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.memberDetails.user_name}
                          onChange={(e) => this.handleMemberDetailsChange('user_name', e)}
                          placeholder="Enter member name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Phone Number <span className="required">(*)</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.memberDetails.phone_number}
                          onChange={(e) => this.handleMemberDetailsChange('phone_number', e)}
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Member No.</label>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.memberDetails.member_no}
                          onChange={(e) => this.handleMemberDetailsChange('member_no', e)}
                          placeholder="Enter member number"
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Sacco <span className="required">(*)</span></label>
                        <Select
                          options={this.props.apps}
                          value={this.state.form_sacco}
                          onChange={(e) => this.onChangeText("form_sacco", e)}
                        />
                        <span className="text-danger">{this.state.error.form_sacco}</span>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Members <span className="required">(*)</span></label>
                        <Select
                          options={this.state.epesi_members}
                          value={this.state.epesi_member}
                          onChange={(e) => this.onChangeText("epesi_member", e)}
                          isMulti
                          isLoading={this.state.isLoadingClient}
                        />
                        <span className="text-danger">{this.state.error.epesi_member}</span>

                        {this.state.epesi_members.length > 0 && (
                          <label>
                            <input
                              type="checkbox"
                              value={this.state.isAllMembers}
                              onChange={this.onCheck.bind(this)}
                            />{" "}
                            Import {this.state.epesi_members.length} member(s)
                          </label>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Body>
          <Footer>
            <button
              type="button"
              class="btn btn-secondary"
              onClick={() => this.handleCloseModal("form_modal")}
              style={{ marginRight: 25 }}
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              onClick={() => this.onSubmit()}
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </Footer>
        </Modal>
      </div>
    );
  }
}

export default Clients;
